import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { GridColDefPro } from '@/global/components/DataGrid/utils/types'
import { hasPermission } from '@/hooks/useBackendMenu'
import { PencilIcon, Trash2Icon } from 'lucide-react'
import { RegraCalculoPresenter } from 'service/api'

type Typography = {
    color?: string
}

export interface IHorasExtras {
    nome: string
    compensaDemaisHrs: boolean
    compensaPrimeirasHrs: boolean
    porcentagemDemaisHrs: number | null
    porcentagemPrimeirasHrs: number | null
    qtdPrimeirasHrs: string
    sigla: string
    todas: boolean
    typographyProps: Typography
    prioridadeCompensacao: 'maior' | 'menor'
}

const diasSemana: {
    nome: string
    sigla: string
}[] = [
    { nome: 'Segunda', sigla: 'seg' },
    { nome: 'Terça', sigla: 'ter' },
    { nome: 'Quarta', sigla: 'qua' },
    { nome: 'Quinta', sigla: 'qui' },
    { nome: 'Sexta', sigla: 'sex' },
]

export const horasExtrasModel = {
    nome: '',
    compensarInjustificadas: true,
    compensarJustificadas: true,
    compensacaoFifo: false,
    horasInterjornada: '11:00',
    horasExtrasFeriado: false,
    horasExcedentesConsideraDiaInteiro: true,
    faltaAutomatica: null,
    horasExtras: {
        sem: {
            nome: 'Segunda a Sexta',
            sigla: 'semana',
            compensaDemaisHrs: true,
            compensaPrimeirasHrs: true,
            qtdPrimeirasHrs: '02:00',
            porcentagemPrimeirasHrs: 50,
            porcentagemDemaisHrs: 75,
            todas: false,
            typographyProps: {} as Typography,
            prioridadeCompensacao: 'maior' as const,
        },
        ...diasSemana.reduce(
            (acc, dia) => {
                acc[dia.sigla] = {
                    ...dia,
                    compensaDemaisHrs: true,
                    compensaPrimeirasHrs: true,
                    qtdPrimeirasHrs: '02:00',
                    porcentagemPrimeirasHrs: 50,
                    porcentagemDemaisHrs: 75,
                    todas: false,
                    typographyProps: {} as Typography,
                    prioridadeCompensacao: 'maior' as const,
                }
                return acc
            },
            {} as { [key: string]: IHorasExtras },
        ),
        sab: {
            nome: 'Sábado',
            sigla: 'sab',
            compensaDemaisHrs: true,
            compensaPrimeirasHrs: true,
            qtdPrimeirasHrs: '02:00',
            porcentagemPrimeirasHrs: 50,
            porcentagemDemaisHrs: 75,
            todas: false,
            typographyProps: {} as Typography,
            prioridadeCompensacao: 'maior' as const,
        },
        dom: {
            nome: 'Domingo',
            sigla: 'dom',
            compensaDemaisHrs: false,
            compensaPrimeirasHrs: false,
            qtdPrimeirasHrs: '',
            porcentagemPrimeirasHrs: 100,
            porcentagemDemaisHrs: null,
            todas: true,
            typographyProps: {
                color: '#c3c3c3',
            },
            prioridadeCompensacao: 'maior' as const,
        },
        fer: {
            nome: 'Feriado',
            sigla: 'fer',
            qtdPrimeirasHrs: '',
            compensaDemaisHrs: false,
            compensaPrimeirasHrs: true,
            porcentagemPrimeirasHrs: null,
            porcentagemDemaisHrs: null,
            todas: true,
            typographyProps: {
                color: '#c3c3c3',
            },
            prioridadeCompensacao: 'maior' as const,
        },
    },
    porcentagens: [
        {
            porcentagem: 50,
            compensacao: 100,
            persiste: true,
        },
        {
            porcentagem: 75,
            compensacao: 100,
            persiste: true,
        },
        { porcentagem: 100, compensacao: 200, persiste: true },
    ],
    adicionalNoturno: 20,
}

export const columns: GridColDefPro<RegraCalculoPresenter>[] = [
    {
        field: 'nome',
        headerName: 'Nome da regra',
        flex: 1,
    },
    {
        ...optionsColumn,
        field: '__editar',
        renderCell: ({ id }) =>
            hasPermission(['update', 'RegrasDeCálculo'], () => (
                <IconButton title="Editar" href={`${id}/editar`}>
                    <PencilIcon />
                </IconButton>
            )),
    },
    {
        ...optionsColumn,
        field: '__excluir',
        renderCell: ({ id }) =>
            hasPermission(['delete', 'RegrasDeCálculo'], () => (
                <IconButton title="Excluir" href={`${id}/excluir`}>
                    <Trash2Icon className="text-error" />
                </IconButton>
            )),
    },
]
